<div class="slack-message" [innerHTML]="content | safeHtml"></div>
